module.exports = __webpack_public_path__ + "img/linePoint.76a943ac.png";